<!--  -->
<template>
  <div class="BottomNav">
    <div class="bottom-box1">
      <div class="bottom-main">
        <ul class="bottomlist">
          <li v-for="(item, key) in bottomNav" :key="key">
            <h1>
              <router-link :to="item.url">
                {{ item.title }}
              </router-link>
            </h1>
            <h2 v-for="(childitem, childkey) in item.children" :key="childkey">
              <router-link :to="childitem.url">
                {{ childitem.title }}
              </router-link>
            </h2>
          </li>
        </ul>
        <div class="erweima-box" v-if="iconShow">
          <div class="erweima">
            <img src="../assets/erweima.png" height="120" width="120" />
          </div>
          <p>{{ erweima }}</p>
        </div>
        <div class="tubiao-box" v-if="!iconShow">
          <div class="iconB">
            <a href="https://www.facebook.com/broncusmedical" target="_blank">
              <img src="../assets/iconF.png" />
            </a>
          </div>
          <div class="iconB">
            <a href="https://twitter.com/Broncus?s=20" target="_blank">
              <img src="../assets/iconTwitter.png" />
            </a>
          </div>
          <div class="iconB">
            <a
              href="https://www.linkedin.com/company/broncus-technologies"
              target="_blank"
            >
              <img src="../assets/iconIn.png" />
            </a>
          </div>
          <div class="iconB">
            <a href="mailto:sales@broncus.com" target="_blank">
              <img src="../assets/iconEmail.png" />
            </a>
          </div>
          <div class="iconB">
            <a
              href="https://www.youtube.com/channel/UCx5SZXib1JGpNgeCdizEnGQ"
              target="_blank"
            >
              <img src="../assets/iconYoutube.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box2">
      <p>{{ address }} &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;{{ phone }}</p>
      <p>
        {{ banquan }}
        <a :href="beianUrl" target="_blank">{{ beian }}</a>
        &nbsp; {{ gongan }}
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dz: "",
      lxdh: "",
      address: "",
      phone: "",
      banquan: "",
      beian: "",
      gongan: "",
      bottomNav: [
        /* 
        {
          title: "关于堃博",
          url: "",
          children: [
            {
              title: "公司介绍",
              url: "",
            },
            {
              title: "发展历程",
              url: "",
            },
            {
              title: "管理团队",
              url: "",
            },
            {
              title: "企业社会责任",
              url: "",
            },
          ],
        },
        {
          title: "关于堃博",
          url: "",
          children: [
            {
              title: "公司介绍",
              url: "",
            },
            {
              title: "发展历程",
              url: "",
            },
            {
              title: "管理团队",
              url: "",
            },
            {
              title: "企业社会责任",
              url: "",
            },
          ],
        },
        {
          title: "关于堃博",
          url: "",
          children: [
            {
              title: "公司介绍",
              url: "",
            },
            {
              title: "发展历程",
              url: "",
            },
            {
              title: "管理团队",
              url: "",
            },
            {
              title: "企业社会责任",
              url: "",
            },
          ],
        },
        {
          title: "关于堃博",
          url: "",
          children: [
            {
              title: "公司介绍",
              url: "",
            },
            {
              title: "发展历程",
              url: "",
            },
            {
              title: "管理团队",
              url: "",
            },
            {
              title: "企业社会责任",
              url: "",
            },
          ],
        },
        {
          title: "关于堃博",
          url: "",
          children: [
            {
              title: "公司介绍",
              url: "",
            },
            {
              title: "发展历程",
              url: "",
            },
            {
              title: "管理团队",
              url: "",
            },
            {
              title: "企业社会责任",
              url: "",
            },
          ],
        },
       */
      ],
      erweima: "",
      iconShow: false,

      beianUrl: "https://beian.miit.gov.cn/",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.底部导航
    get_nav() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_nav",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (!obj.region) {
            that.iconShow = true;
          } else {
            that.iconShow = false;
          }
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              if (i > 0) {
                var linshi = [];
                $.each(k.two_cat, function (ii, kk) {
                  linshi.push({
                    title: kk.title,
                    url: kk.url,
                  });
                });
                that.bottomNav.push({
                  title: k.title,
                  url: k.url,
                  children: linshi,
                });
              }
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.页脚信息
    get_footer() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_config",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            if (obj.lang) {
              if (obj.lang == "1") {
                //英文
                that.address = obj.data[11].value;
                if(obj.region == 1){
                  that.phone = obj.data[14].value;
                }
                if(obj.region == 2){
                  that.phone = obj.data[23].value;
                }
              } else if (obj.lang == "6") {
                //繁体
                that.address = obj.data[12].value;
                that.phone = obj.data[15].value;
              } else {
                //简体
                that.address = obj.data[5].value;
                that.phone = obj.data[13].value;
              }
            } else {
              //简体
              that.address = obj.data[5].value;
              that.phone = obj.data[13].value;
            }
            if (obj.region == 1) {
              that.banquan = obj.data[19].value;
              that.beian = obj.data[20].value;
              that.gongan = "";
              that.beianUrl = "javascript;";
            } else if (obj.region == 2) {
              that.banquan = obj.data[19].value;
              that.beian = obj.data[21].value;
              that.gongan = "";
              that.beianUrl = "javascript;";
            } else if (obj.region == 3) {
              that.banquan = obj.data[22].value;
            } else {
              that.banquan = obj.data[17].value;
              that.beian = obj.data[3].value;
              that.gongan = obj.data[16].value;
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.dz = obj.data["dz"];
            that.lxdh = obj.data["lxdh"];
            that.erweima = obj.data["smgz"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_nav();
    this.get_footer();
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.BottomNav {
  //   position: absolute;
  //   bottom: 0;
  width: 100%;
  .bottom-box1 {
    width: 100%;
    background-color: #0069b5;
    min-height: 340px;
    padding-bottom: 20px;
    .bottom-main {
      width: $main-width;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .bottomlist {
        width: 82%;
        display: flex;
        justify-content: space-between;
        li {
          margin-right: 20px;
          color: $text-color;
          h1 {
            margin-top: 50px;
            letter-spacing: 1px;
            font-size: 1.3rem;
          }
          h2 {
            font-size: 14px;
            margin-top: 12px;
            letter-spacing: 1px;
          }
          h2:nth-child(2) {
            margin-top: 30px;
          }
        }
      }
      .erweima-box {
        text-align: center;
        .erweima {
          margin-top: 88px;
        }
        p {
          margin-top: 20px;
          color: $text-color;
          font-size: 0.85rem;
        }
      }
      .tubiao-box {
        display: flex;
        align-items: flex-end;
        .iconB {
          width: 35px;
          height: 35px;
          margin: 0 5px 40px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .bottom-box2 {
    width: 100%;
    padding: 40px 0 30px 0;
    background-color: #ffffff;
    text-align: center;
    p {
      font-size: 0.75rem;
      color: #666666;
    }
  }
}
@media screen and (max-width: $main-width) {
  .BottomNav {
    .bottom-box1 {
      display: none;
    }
    .bottom-box2 {
      width: 100%;
      padding: 20px 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BottomNav.vue